import React from 'react';
import { motion } from 'framer-motion';

const rankingData = [
    {
        id: 1,
        rank: "No. 4",
        description: "on the Great Place To Work® Fortune World's Best Workplaces™, our 4th consecutive year on the list."
    },
    {
        id: 2,
        rank: "No. 10",
        description: "on the Great Place To Work® Fortune World's Best Workplaces™, our 4th consecutive year on the list."
    },
    {
        id: 3,
        rank: "No. 11",
        description: "on the Great Place To Work® Fortune World's Best Workplaces™, our 4th consecutive year on the list."
    },
    {
        id: 4,
        rank: "No. 24",
        description: "on the Great Place To Work® Fortune World's Best Workplaces™, our 4th consecutive year on the list."
    }
];

const GreatPlaceToWorkSection = () => {
    const fadeUpVariant = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
    };

    const slideRightVariant = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.15 }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, x: 30 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    return (
        <section className="w-full pb-[40px] md:pb-[100px] bg-white relative">
            <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    variants={fadeUpVariant}
                    className="flex flex-col items-center text-center mb-[32px] md:mb-[80px]"
                >
                    <h2 className="font-sora text-[20px] lg:text-[30px] font-[600] text-[#01386A] tracking-tight mb-[12px] md:mb-[15px]">
                        A great place to work
                    </h2>
                    <p className="font-graphik text-[#6C7689] text-[14px] md:text-[16px] font-[500] max-w-[642px] leading-[1.6]">
                        Our people power our business and talent strategy, and we want to be the best place for our Reinventors to learn, grow and thrive.
                    </p>
                </motion.div>

                <div className="flex flex-col lg:flex-row items-start gap-[32px] lg:gap-[60px] relative">

                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        variants={slideRightVariant}
                        className="w-full lg:w-1/2 lg:sticky lg:top-[120px]"
                    >
                        <img
                            src="/assets/awards/img3.png"
                            alt="Abstract Purple 3D Shape"
                            className="w-full h-auto max-h-[260px] sm:max-h-[350px] lg:max-h-none object-cover"
                        />
                    </motion.div>

                    <motion.div
                        variants={containerVariants}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        className="w-full lg:w-1/2 flex flex-col gap-[16px] md:gap-[20px]"
                    >
                        {rankingData.map((item) => (
                            <motion.div
                                key={item.id}
                                variants={itemVariants}
                                className="group relative bg-white border border-[#01386A45] p-[20px] sm:p-[24px] md:p-[32px] md:hover:-translate-y-1 md:hover:shadow-[0_10px_30px_rgba(1,56,106,0.08)] transition-all duration-300 overflow-hidden cursor-pointer rounded-sm"
                            >
                                <h3 className="font-sora text-[16px] md:text-[20px] font-[600] text-[#01386A] lg:mb-[48px] mb-[20px] sm:mb-[30px]">
                                    {item.rank}
                                </h3>
                                <p className="font-graphik text-[#49577A] text-[14px] md:text-[16px] font-[500] leading-[1.6]">
                                    {item.description}
                                </p>

                                <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A] z-20"></div>
                                <div className="absolute bottom-0 left-0 w-0 h-[4px] bg-[#ED6800] transition-all duration-500 ease-out group-hover:w-full z-30"></div>
                            </motion.div>
                        ))}
                    </motion.div>

                </div>
            </div>
        </section>
    );
};

export default GreatPlaceToWorkSection;